import {Filter} from "bad-words";

const filter = new Filter();

export const hasBadWords = (text: string) => {
  if (!text) return false;

  const normalized = text.toLowerCase();

  // split words
  const words = normalized.split(/\s+/);

  // check each word using the filter's built-in profanity detection
  return words.some(word => filter.isProfane(word));

};